import { useState } from "react";
import FileUploadField from "../../components/FileUploadField";
import FormSuccess from "../../components/FormSuccess";
import { useSubmission } from "../../utils/useSubmission";

const SCOPE_OPTIONS = [
  "Marine & River Logistics", "Heavy Lift & Cranes", "Construction & Fabrication",
  "Engineering Services", "Camp, Catering & Accommodation", "Equipment & General Supply",
];

const BLANK = {
  companyName: "", country: "South Korea", businessRegistrationNumber: "",
  contactPerson: "", contactEmail: "", contactPhone: "", companySummary: "",
};

export default function CompanySubmissionPage() {
  const [f, setF] = useState(BLANK);
  const [scopes, setScopes] = useState([]);
  const [files, setFiles] = useState([]);
  const { submitting, error, setError, success, submit } = useSubmission({
    collectionName: "companySubmissions", storageFolder: "company-submissions",
  });

  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));
  const toggleScope = s => setScopes(prev => prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]);

  const onSubmit = e => {
    e.preventDefault();
    if (!f.companyName || !f.contactPerson || !f.contactEmail || !f.companySummary) {
      setError("Please fill in all required fields.");
      return;
    }
    submit({ ...f, scopeOfWork: scopes }, files);
  };

  if (success) {
    return (
      <section className="sec"><div className="container">
        <FormSuccess title="Submission Received"
          message="Thank you — your company's profile and documents have been received. Relevant submissions are routed into the Korean logistics chain's subcontracting review." />
      </div></section>
    );
  }

  return (
    <>
      <div className="pg-hdr">
        <h1>Korean Company Subcontract Submission</h1>
        <p>For Korean companies with capability relevant to the Papua LNG upstream construction and logistics scope.</p>
      </div>
      <section className="sec">
        <div className="container">
          <form className="form-card fade-up" onSubmit={onSubmit}>
            {error && <div className="form-err-banner">{error}</div>}

            <div className="field-row">
              <div className="field">
                <label>Company Name <span className="req">*</span></label>
                <input value={f.companyName} onChange={e => set("companyName", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Country</label>
                <input value={f.country} onChange={e => set("country", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Business Registration Number</label>
              <input value={f.businessRegistrationNumber} onChange={e => set("businessRegistrationNumber", e.target.value)}/>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Contact Person <span className="req">*</span></label>
                <input value={f.contactPerson} onChange={e => set("contactPerson", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Contact Email <span className="req">*</span></label>
                <input type="email" value={f.contactEmail} onChange={e => set("contactEmail", e.target.value)} required/>
              </div>
            </div>

            <div className="field">
              <label>Contact Phone</label>
              <input value={f.contactPhone} onChange={e => set("contactPhone", e.target.value)}/>
            </div>

            <div className="field">
              <label>Scope of Work</label>
              <div className="row-btns">
                {SCOPE_OPTIONS.map(s => (
                  <button key={s} type="button"
                    className={scopes.includes(s) ? "btn-g" : "btn-gray"}
                    onClick={() => toggleScope(s)}>
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div className="field">
              <label>Company Summary / Capability Statement <span className="req">*</span></label>
              <textarea value={f.companySummary} onChange={e => set("companySummary", e.target.value)}
                placeholder="Briefly describe your company, relevant experience and capability" required/>
            </div>

            <FileUploadField label="Company Registration & Capability Documents"
              hint="Business registration, capability statement, references, PDF or Word, max 10MB each"
              files={files} setFiles={setFiles} onError={setError}/>

            <button className="btn-g" style={{ width: "100%", marginTop: ".5rem" }} disabled={submitting}>
              {submitting ? "Submitting…" : "Submit Company Profile →"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
